import React from 'react';
import PropTypes from 'prop-types';
import CurrentPageContext from '../../../../../contexts/CurrentPageContext';
import styles from './Size.scss';

export default class Size extends React.Component {
  static propTypes = {
    size: PropTypes.string.isRequired,
    renderSize: PropTypes.bool,
    isModal: PropTypes.bool,
  };

  static defaultProps = {
    renderSize: undefined,
    isModal: undefined,
  }

  static contextType = CurrentPageContext;

  renderSizeForThemes() {
    const { primaryColorClass } = this.context;
    const { size, renderSize, isModal } = this.props;
    if (renderSize && !isModal) {
      return (
        <div className={`${styles.size} ${primaryColorClass}`}>
          {size}
        </div>
      );
    }
    return (
      <div className={styles.root} data-testid="unitSize">
        {size}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSizeForThemes()}
      </div>
    );
  }
}
